import adminService from '@/api/admin.service'

const actions = {
  // getCompanyList: (context) => {
  //   let companyListLoaded = new Promise((resolve, reject) => {
  //     adminService.getCompanyList(context)
  //       .then(response => {
  //         context.commit('companyList', response)
  //         resolve(response)
  //       }).catch(e => {
  //         reject(e)
  //       })
  //   })
  //   return companyListLoaded
  // },
  getCompanyInfo: context => {
    let company = new Promise((resolve, reject) => {
      adminService
        .getCompanyInfo(context)
        .then(response => {
          context.commit('companyInfo', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return company
  },
  getCICompanyInfo: (context, companyName) => {
    let company = new Promise((resolve, reject) => {
      adminService
        .getCICompanyInfo(context, companyName)
        .then(response => {
          localStorage.setItem('corporateIdentityInfo', JSON.stringify(response))
          context.commit('companyInfo', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return company
  },
  setCICompanyInfo: (context, companyInfo) => {
    if (companyInfo) {
      localStorage.removeItem('corporateIdentityInfo')
      localStorage.setItem('corporateIdentityInfo', JSON.stringify(companyInfo))
      context.commit('companyInfo', companyInfo)
    } else {
      localStorage.removeItem('corporateIdentityInfo')
      context.commit('companyInfo', {})
    }
  },
  getCompanyInfoByCompanyId: (context, companyId) => {
    let company = new Promise((resolve, reject) => {
      adminService
        .getCompanyInfoByCompanyId(context, companyId)
        .then(response => {
          context.commit('selectedCompany', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return company
  },
  selectCompany: (context, companyInfo) => {
    context.commit('selectedCompany', companyInfo)
  },
  getCompaniesList: context => {
    let companyListLoaded = new Promise((resolve, reject) => {
      adminService
        .getCompaniesList(context)
        .then(response => {
          context.commit('companyList', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return companyListLoaded
  },
  getCandidatesList: context => {
    let candidateListLoaded = new Promise((resolve, reject) => {
      adminService
        .getCandidatesList(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return candidateListLoaded
  },
  upgradeCloseup: (context, data) => {
    return new Promise((resolve, reject) => {
      adminService
        .upgradeCloseup(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
  },
  getRecruitersList: context => {
    let recruiterListLoaded = new Promise((resolve, reject) => {
      adminService
        .getRecruitersList(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return recruiterListLoaded
  },
  getRecruitersByCompany: (context, compId) => {
    let recruiterListLoaded = new Promise((resolve, reject) => {
      adminService
        .getRecruitersByCompany(context, compId)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return recruiterListLoaded
  },
  getProductsByCompany: (context, compId) => {
    let responseLoaded = new Promise((resolve, reject) => {
      adminService
        .getProductsByCompany(context, compId)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return responseLoaded
  },
  getProducts: context => {
    let products = new Promise((resolve, reject) => {
      adminService
        .getProducts(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return products
  },
  getVouchers: context => {
    let vouchers = new Promise((resolve, reject) => {
      adminService
        .getVouchers(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return vouchers
  },
  activateUserAccount: (context, activateUserModel) => {
    let activatedUser = new Promise((resolve, reject) => {
      adminService
        .activateUserAccount(context, activateUserModel)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return activatedUser
  },
  activateCompany: (context, payload) => {
    let activatedUser = new Promise((resolve, reject) => {
      adminService
        .activateCompany(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return activatedUser
  },
  activateCIFeatures: (context, payload) => {
    const resp = new Promise((resolve, reject) => {
      adminService
        .activateCIFeatures(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return resp
  },
  deleteUserAccount: (context, deleteUserModel) => {
    let deletedUser = new Promise((resolve, reject) => {
      adminService
        .deleteUserAccount(context, deleteUserModel)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return deletedUser
  },
  uploadInterview: (context, uploadInterviewModel) => {
    let uploadedInterview = new Promise((resolve, reject) => {
      adminService
        .uploadInterview(context, uploadInterviewModel)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return uploadedInterview
  },
  deleteApplicant: (context, deleteApplicant) => {
    let deletedCandidate = new Promise((resolve, reject) => {
      adminService
        .deleteApplicant(context, deleteApplicant)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return deletedCandidate
  },
  deleteCompany: (context, deleteCompanyModel) => {
    let deletedCompany = new Promise((resolve, reject) => {
      adminService
        .deleteCompany(context, deleteCompanyModel)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return deletedCompany
  },
  getBookingList: context => {
    let bookingListLoaded = new Promise((resolve, reject) => {
      adminService
        .getBookingList(context)
        .then(response => {
          context.commit('bookingList', response)
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return bookingListLoaded
  },
  getAppliedListByProduct: (context, data) => {
    let bookingListLoaded = new Promise((resolve, reject) => {
      adminService
        .getAppliedListByProduct(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return bookingListLoaded
  },
  getCandidateUploadedVideos: (context, data) => {
    let videosList = new Promise((resolve, reject) => {
      adminService
        .getCandidateUploadedVideos(context, data)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return videosList
  },
  createProduct: (context, model) => {
    let product = new Promise((resolve, reject) => {
      adminService
        .createProduct(context, model)
        .then(response => {
          resolve(response)
        })
        .then(() => {
          context.commit('bookingList')
        })
        .catch(e => {
          reject(e)
        })
    })
    return product
  },
  bookCandidateDossier: (context, model) => {
    let product = new Promise((resolve, reject) => {
      adminService
        .bookCandidateDossier(context, model)
        .then(response => {
          resolve(response)
        })
        .then(() => {
          context.commit('bookingList')
        })
        .catch(e => {
          reject(e)
        })
    })
    return product
  },
  createVoucher: (context, model) => {
    let voucher = new Promise((resolve, reject) => {
      adminService
        .createVoucher(context, model)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return voucher
  },
  deleteVoucher: (context, model) => {
    let voucher = new Promise((resolve, reject) => {
      adminService
        .deleteVoucher(context, model)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return voucher
  },
  fetchEmailAlerts: context => {
    let savedAlerts = new Promise((resolve, reject) => {
      adminService
        .fetchEmailAlerts(context)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return savedAlerts
  },
  saveEmailAlerts: (context, payload) => {
    let savedAlerts = new Promise((resolve, reject) => {
      adminService
        .saveEmailAlerts(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return savedAlerts
  },
  uploadCompanyGalleryImage: (context, payload) => {
    let savedAlerts = new Promise((resolve, reject) => {
      adminService
        .uploadCompanyGalleryImage(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return savedAlerts
  },
  removeCompanyGalleryImage: (context, payload) => {
    let savedAlerts = new Promise((resolve, reject) => {
      adminService
        .removeCompanyGalleryImage(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return savedAlerts
  },
  updateTranscribeText: (context, payload) => {
    let transcribedText = new Promise((resolve, reject) => {
      adminService
        .updateTranscribeText(context, payload)
        .then(response => {
          resolve(response)
        })
        .catch(e => {
          reject(e)
        })
    })
    return transcribedText
  },
}

export default actions
